<template>
  <div class="row">
    <div class="col-md-4">
      <label> {{ name }} </label>
    </div>
    <div class="col-md-8">
      <select class="form-control-sm" style="min-width: 100%; max-width: 100%"
              @input="processDropdown" v-model="selectedValue"
              :disabled="disabled" :data-help="help">
        <option v-if="showDefaultValue" :value="defaultEmptyValue">
          {{ defaultEmptyValueMessage }}
        </option>
        <option :value="option[valueField]" :key="option[valueField]" v-for="option in options">
          {{ option[descriptionField] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import {useStore} from 'vuex'
import {ref, onMounted} from 'vue'

export default {
  name: 'AttributeDropdownGeneric',
  props: {
    id: String,
    value: String,
    name: String,
    attId: Number,
    disabled: Boolean,
    attInfoId: Number,
    ownerId: Number,
    options: {
      type: Array,
      required: true
    },
    valueField: {
      type: String,
      default: 'id'
    },
    descriptionField: {
      type: String,
      default: 'name'
    },
    showDefaultValue: {
      type: Boolean,
      default: true
    },
    defaultEmptyValue: {
      type: String,
      default: '0'
    },
    defaultEmptyValueMessage: {
      type: String,
      default: 'Please choose value'
    },
    listType: String,
    AutoSave: Boolean,
    help: String
  },
  setup(props) {
    const store = useStore();
    const selectedValue = ref(props.value || props.defaultEmptyValue);

    onMounted(() => {
      // Initialize with the provided value if available
      if (props.value && props.value !== 'false') {
        selectedValue.value = props.value;
      }
    });

    function processDropdown(e) {
      const val = e.target.value;
      console.log('AttributeDropdownGeneric value changed: ' + val);

      // val is zero when we're on the selection message
      if (val == 0) {
        return;
      }

      // Dispatch upsert attribute action
      store.dispatch('user/upsertAttribute', {
        attribute_value: val,
        attribute_info_id: props.attInfoId,
        owner_id: props.ownerId,
        listType: props.listType
      });
    }

    return {
      selectedValue,
      processDropdown
    }
  },
}
</script>

<style scoped>
option {
  background-color: var(--color-bg-sec);
}
</style>
